import { AttributionModel } from "@redotech/redo-attribution-common/attribution-settings";
import { attributedMarketingMetricsSchema } from "@redotech/redo-marketing-common/attributed-marketing-metrics";
import * as zExt from "@redotech/rpc/ext";
import * as z from "zod";

export const getAttributedMarketingMetrics = {
  name: "getAttributedMarketingMetrics" as const,
  input: z
    .object({
      attributionModel: z.enum(AttributionModel),
      from: zExt.instant().describe("Start instant, inclusive"),
      to: zExt.instant().describe("End instant, exclusive"),
    })
    .refine((input) => Temporal.Instant.compare(input.from, input.to) < 0, {
      message: "from must be before to",
    }),
  output: attributedMarketingMetricsSchema,
};
